import React, { useMemo } from "react";
import { useCompanyId } from "src/Pages/Company/CompanyContext";
import { Box, Skeleton, Typography } from "@mui/material";
import { IDataCards } from "src/Pages/Company/OrganizationStructure/ConfigureStructure/Tabs/StructureAreas/DataManagment/Area";
import DataCard from "src/Pages/Company/OrganizationStructure/ConfigureStructure/Tabs/StructureAreas/DataManagment/Area/DataCard";
import { useFetchStructureData } from "src/Pages/Company/EmployeeManagement/CompanyEmployees/Edit/OrganizationStructure/api/useFetchStructureData";
import {
  organizationStructureEmployeeDataExport,
  // organizationStructureEmployeeDataImport,
} from "src/utils/RoleBasedSecurity/permissions";
import { usePermission } from "src/utils/hooks/permissions/usePermissions";
import BreadcrumbsMui from "src/Components/BreadcrumbsMui/BreadcrumbsMui";
import __ from "src/utils/Translations";
import { useCompanyBreadcrumbs } from "src/Pages/Company/breadcrumbsHelper";
import Export from "./Buttons/Export";

const DataManagement = () => {
  const companyId = useCompanyId();
  const { data, isFetching } = useFetchStructureData(companyId);

  const structureId = isFetching ? "" : data?.[0]?.structureId;

  // const hasPermissionsImport = usePermission(
  //   organizationStructureEmployeeDataImport
  // );
  const hasPermissionsExport = usePermission(
    organizationStructureEmployeeDataExport
  );

  const dataCards: IDataCards[] = useMemo(() => {
    const cards: IDataCards[] = [];

    // if (hasPermissionsImport) {
    //   cards.push(
    //     {
    //       mainText: "Pobierz szablon do importu",
    //       secondaryText:
    //         "Pobierz szablon, który będzie można uzupełnić danymi pracowników.",
    //       type: "download",
    //       actionButtons: (
    //         <Button
    //           variant="contained"
    //           sx={{
    //             width: "100%",
    //             fontSize: "13px",
    //             fontWeight: "700",
    //             margin: "auto 0 0 0",
    //           }}
    //         >
    //           {__("Pobierz")}
    //         </Button>
    //       ),
    //     },
    //     {
    //       mainText: "Importuj przygotowany plik",
    //       secondaryText: "Wgraj dane swoich pracowników.",
    //       type: "upload",
    //       actionButtons: (
    //         <Button
    //           variant="contained"
    //           sx={{
    //             width: "100%",
    //             fontSize: "13px",
    //             fontWeight: "700",
    //             margin: "auto 0 0 0",
    //           }}
    //         >
    //           {__("Importuj")}
    //         </Button>
    //       ),
    //     }
    //   );
    // }

    if (hasPermissionsExport) {
      cards.push({
        mainText: "Eksportuj do pliku",
        secondaryText: "Eksportuj do pliku dane swoich pracowników.",
        type: "download",
        actionButtons: (
          <Export structureId={structureId as string} companyId={companyId} />
        ),
      });
    }

    return cards;
  }, [
    companyId,
    structureId,
    // hasPermissionsImport,
    hasPermissionsExport,
  ]);

  const breadcrumbs = useCompanyBreadcrumbs([
    {
      label: __("Struktura organizacji"),
      path: "/organization-structure",
    },
    {
      label: __("Import/Export danych pracownika"),
      path: "/organization-structure/import-export-data",
    },
  ]);

  return (
    <>
      <BreadcrumbsMui items={breadcrumbs} sx={{ marginBottom: "32px" }} />
      <Typography
        sx={{ fontSize: "24px", textTransform: "upperCase" }}
        fontWeight="fontWeightBold"
      >
        {__("Import/Export danych pracownika")}
      </Typography>
      <Box
        sx={{
          margin: "46px 0 0 0",
          display: "flex",
          gap: "24px",
          flexWrap: "wrap",
        }}
      >
        {isFetching ? (
          <Skeleton variant="rounded" height={288} width={365} />
        ) : (
          dataCards.map(({ mainText, secondaryText, actionButtons, type }) => (
            <DataCard
              mainText={mainText}
              secondaryText={secondaryText}
              actionButtons={actionButtons}
              type={type}
            />
          ))
        )}
      </Box>
    </>
  );
};

export default DataManagement;
